import { render, staticRenderFns } from "./ChineseForm.vue?vue&type=template&id=45e8fe35&"
import script from "./ChineseForm.vue?vue&type=script&lang=js&"
export * from "./ChineseForm.vue?vue&type=script&lang=js&"
import style0 from "./ChineseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports